interface CustomWindowInterface extends Window {
  dataLayer: Array<{ [key: string]: string }>;
}

export const CustomWindowExport: CustomWindowInterface = window as unknown as CustomWindowInterface;
